import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'font-awesome/css/font-awesome.min.css';
import 'typeface-roboto';
import App from './App';
import './views/core/ToastPage.js';
import './views/core/LoggedOutPrompt.js';
import './views/core/ErrorPrompt.js';
//import './util/IcePieTracker.js';
import './vendors/FbCampaignTrack.js';
import './vendors/LumosHeartBeat.js';
import './vendors/LumosPrepPunchIn.js';

import './vendors/PLPPrepPunchIn.js';
import './vendors/AppPrepPunchIn';
import './hmevents/NetChecker.js';
import './components/common/NetworkCheck.js';
import './views/common/DefaultMask';
import registerServiceWorker from './registerServiceWorker';
import './components/common/ContestQuesAlert';
import './views/common/ViewSolutionWindow';

try{
	window.showConsole = (window.devMode) ? true : false;
}catch(e){}
 if(console && !window.showConsole){
	var CONSOLE_MODES_ALLOWED = ["error","warn"];
		
	for(var i in console){
		if(CONSOLE_MODES_ALLOWED.indexOf(i) < 0){
			console[i] = () => {};	
		}
	}
} 

ReactDOM.render(<App />, document.getElementById('root'));


try{
	window.alert = console.warn || function(){};
}catch(e){}

if(window.isSWCacheEnabled){
	registerServiceWorker();
}

//To unregister serviceWorker
try{
	if(!window.isSWCacheEnable && navigator.serviceWorker){
		navigator.serviceWorker.ready.then(registration => {registration.unregister();});	
	}	
}catch(e){}


// WEBPACK FOOTER //
// ./src/index.js